<template>
  <el-card class="tree-card">
    <div class="room-tree-title">房屋结构</div>
    <el-tree
      ref="tree"
      :data="treeData"
      node-key="id"
      :props="defaultProps"
      :highlight-current="true"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
    >
      <span slot-scope="{ node, data }" class="custom-tree-node">
        <i :class="structureIcon(data)" class="tree-node-icon"></i>
        <span class="tree-node-label">{{ structureLabel(data, node.label) }}</span>
      </span>
    </el-tree>
  </el-card>
</template>

<script>
import { queryCommunityUnitTree } from '@/api/community/adminRoomApi'

export default {
  name: 'CommunityUnitTree',
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      }
    }
  },
  methods: {
    async loadTreeData() {
      try {
        const { data } = await queryCommunityUnitTree({ hc: 1.8 })
        console.log( data)
        this.treeData = data
        //this.processTreeData(data)
      } catch (error) {
        this.$message.error(this.$t('common.fetchError'))
      }
    },
    processTreeData(data) {
      this.treeData = data.map(community => ({
        id: `c_${community.communityId}`,
        label: community.communityName,
        communityId: community.communityId,
        communityName: community.communityName,
        children: community.floors.map(floor => ({
          id: `f_${floor.floorId}`,
          label: floor.floorNum,
          floorId: floor.floorId,
          floorNum: floor.floorNum,
          children: floor.units.map(unit => ({
            id: `u_${unit.unitId}`,
            label: unit.unitNum,
            unitId: unit.unitId,
            unitNum: unit.unitNum
          }))
        }))
      }))
    },
    handleNodeClick(data) {
      if (data.id.startsWith('c_')) {
        this.$emit('selectCommunity', {
          communityId: data.communityId,
          communityName: data.communityName
        })
      } else if (data.id.startsWith('f_')) {
        this.$emit('selectFloor', {
          floorId: data.floorId,
          floorNum: data.floorNum
        })
      } else if (data.id.startsWith('u_')) {
        this.$emit('selectUnit', {
          unitId: data.unitId,
          unitNum: data.unitNum
        })
      }
    },
    structureLabel(data, fallback) {
      if (data.id && data.id.startsWith('f_')) {
        return this.structureSuffix(data.floorNum || fallback, '号楼')
      }
      if (data.id && data.id.startsWith('u_')) {
        return this.structureSuffix(data.unitNum || fallback, '单元')
      }
      return fallback
    },
    structureSuffix(value, suffix) {
      const text = String(value || '').trim()
      return text.endsWith(suffix) ? text : `${text}${suffix}`
    },
    structureIcon(data) {
      if (data.id && data.id.startsWith('c_')) return 'el-icon-location-outline'
      if (data.id && data.id.startsWith('f_')) return 'el-icon-office-building'
      if (data.id && data.id.startsWith('u_')) return 'el-icon-house'
      return 'el-icon-document'
    },
    open() {
      this.loadTreeData()
    }
  }
}
</script>

<style scoped>
.tree-card {
  max-height: 80vh;
  overflow-y: auto;
}
.room-tree-title {
  padding: 0 0 8px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #1f2d3d;
}
.tree-card ::v-deep .el-card__body {
  padding: 12px 8px;
}
.tree-card ::v-deep .el-tree-node__content {
  height: 32px;
  margin-bottom: 2px;
  border-radius: 4px;
}
.tree-card ::v-deep .el-tree-node__content:hover {
  background: #edf4fb;
}
.tree-card ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #fff;
  background: #149582;
}
.tree-card ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content .tree-node-icon,
.tree-card ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content .el-tree-node__expand-icon {
  color: #fff;
}
.custom-tree-node {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.tree-node-icon {
  margin-right: 6px;
  color: #6d86a8;
}
.tree-node-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
